import { createActions, handleActions } from 'redux-actions'
import Immutable, { List, Map } from 'immutable'
import fetch from '@request/fetch'

const CUSTOMER_SEARCH = 'CUSTOMER_SEARCH' // 获取用户配置信息列表
const CUSTOMER_GET = 'CUSTOMER_GET' // 根据配置子账号来查找配置项
const CUSTOMER_WHITE_UPDATE = 'CUSTOMER_WHITE_UPDATE' // 修改用户配置的白词
const CUSTOMER_FILTER_UPDATE = 'CUSTOMER_FILTER_UPDATE' // 批量修改用户的白词列表
const CUSTOMER_WHITE_BATCH_UPDATE = 'CUSTOMER_WHITE_BATCH_UPDATE' // 修改用户的黑词过滤等级
const CUSTOMER_FILTER_BATCH_UPDATE = 'CUSTOMER_FILTER_BATCH_UPDATE' // 批量修改～
const CUSTOMER_PULL = 'CUSTOMER_PULL' // 手动同步用户配置
const CUSTOMER_PULL_TASK_GET = 'CUSTOMER_PULL_TASK_GET' // 获取用户数据同步任务详情
const CUSTOMER_UPDATE_IGNORE_CASE = 'CUSTOMER_UPDATE_IGNORE_CASE' // 用户过滤大小写
const CUSTOMER_UPDATE_SPECIAL_CHARS = 'CUSTOMER_UPDATE_SPECIAL_CHARS' // 用户过滤特殊字符
const CUSTOMER_UPDATE_ABNORMAL_CHARS = 'CUSTOMER_UPDATE_ABNORMAL_CHARS' // 用户过滤变体字
const CUSTOMER_UPDATE_SMS_AMOUNT_MONITOR = 'CUSTOMER_UPDATE_SMS_AMOUNT_MONITOR' // 用户过滤特殊字符
const CUSTOMER_UPDATE_NIGHT_SMS_AMOUNT_MONITOR = 'CUSTOMER_UPDATE_NIGHT_SMS_AMOUNT_MONITOR' // 用户过滤特殊字符
const CUSTOMER_UPDATE_RISK_LEVEL = 'CUSTOMER_UPDATE_RISK_LEVEL' // 用户过滤特殊字符

const SEARCH_POLICY_REMARK = 'SEARCH_POLICY_REMARK' // 查询备注详情
const PATCH_POLICY_REMARK = 'PATCH_POLICY_REMARK' // 新增备注
const DELETE_POLICY_REMARK = 'DELETE_POLICY_REMARK' // 删除备注

const defaultState = Immutable.fromJS({
  customers: {
    list: [],
    total: 0
  },
  riskRemarkList: {
    list: [],
    total: 0
  }
})

export const policyAction = createActions({
  CUSTOMER_SEARCH: async params => {
    const result = await fetch.post(`/policy/searchUserConfigs`, params)
    return result
  },
  CUSTOMER_GET: async params => {
    const result = await fetch.post(`/policy/getConfigByConfigId`, params)
    return result
  },
  CUSTOMER_WHITE_UPDATE: async params => {
    const result = await fetch.post(`/policy/updateUserWhiteWord`, params)
    return result
  },
  CUSTOMER_WHITE_BATCH_UPDATE: async params => {
    const result = await fetch.post(`/policy/updateUsersWhiteWord`, params)
    return result
  },
  CUSTOMER_FILTER_UPDATE: async params => {
    const result = await fetch.post(`/policy/patchUserBlackLevel`, params)
    return result
  },
  CUSTOMER_FILTER_BATCH_UPDATE: async params => {
    const result = await fetch.post(`/policy/patchUsersBlackLevel`, params)
    return result
  },
  CUSTOMER_PULL: async params => {
    const result = await fetch.post(`/policy/pullUsersData`, params)
    return result
  },
  CUSTOMER_PULL_TASK_GET: async params => {
    const result = await fetch.get(`/policy/searchTask`, params)
    return result
  },
  CUSTOMER_UPDATE_IGNORE_CASE: async params => {
    const result = await fetch.post(`/policy/updateUserIgnoreCase`, params)
    return result
  },
  CUSTOMER_UPDATE_SPECIAL_CHARS: async params => {
    const result = await fetch.post(`/policy/updateUserSpecialChars`, params)
    return result
  },
  CUSTOMER_UPDATE_ABNORMAL_CHARS: async params => {
    const result = await fetch.post(`/policy/updateUserSmsAbnormalChars`, params)
    return result
  },
  CUSTOMER_UPDATE_CONTINUOUS_NUMBER: async params => {
    const result = await fetch.post(`/policy/updateUserSpecialNumCharacter`, params)
    return result
  },
  CUSTOMER_UPDATE_SMS_AMOUNT_MONITOR: async params => {
    const result = await fetch.post(`/policy/updateUserSmsAmountMonitor`, params)
    return result
  },
  CUSTOMER_UPDATE_NIGHT_SMS_AMOUNT_MONITOR: async params => {
    const result = await fetch.post(`/policy/updateUserNightSmsAmountMonitor`, params)
    return result
  },
  CUSTOMER_UPDATE_RISK_LEVEL: async params => {
    const result = await fetch.post(`/policy/updateUserRiskLevel`, params)
    return result
  },
  CUSTOMER_UPDATE_USER_URL_DEFORMED: async params => {
    const result = await fetch.post(`/policy/updateUserUrlDeformed`, params)
    return result
  },
  SEARCH_POLICY_REMARK: async params => {
    const result = await fetch.post(`/policy/searchConfigRemarks`, params)
    return result
  },
  PATCH_POLICY_REMARK: async params => {
    const result = await fetch.post(`/policy/patchConfigRemarks`, params)
    return result
  },
  DELETE_POLICY_REMARK: async params => {
    const result = await fetch.post(`/policy/deleteRemark`, params)
    return result
  }
})

const reducer = handleActions(
  {
    [CUSTOMER_SEARCH]: (state, action) => {
      let curState = state
      const { totalCount, records } = action.payload
      curState = curState.set(
        'customers',
        new Map({
          list: new List(records),
          total: totalCount
        })
      )
      return curState
    },
    [SEARCH_POLICY_REMARK]: (state, action) => {
      let curState = state
      const { totalCount, records } = action.payload
      curState = curState.set(
        'riskRemarkList',
        new Map({
          list: new List(records),
          total: totalCount
        })
      )
      return curState
    }
  },
  defaultState
)

export default reducer
